import { gql } from "graphql-request";

const SERVER_RESPOND_FEEDBACK_ANSWER = gql`
  mutation SERVER_respondFeedback($input: [FeedbackAnswerInput]!) {
    respondFeedback(input: $input) {
      feedbackQuestionId
    }
  }
`;
export default SERVER_RESPOND_FEEDBACK_ANSWER;